// src/utils/errorHandler.ts
export interface ApiError {
  status?: number;
  message?: string;
  details?: string;
}

export class AppError extends Error {
  public status?: number;
  public details?: string;

  constructor(message: string, status?: number, details?: string) {
    super(message);
    this.name = "AppError";
    this.status = status;
    this.details = details;
  }
}

export const handleApiError = (error: unknown): AppError => {
  if (error instanceof AppError) {
    return error;
  }

  if (error instanceof Error) {
    return new AppError(error.message);
  }

  if (typeof error === "object" && error !== null) {
    const apiError = error as ApiError;
    return new AppError(
      apiError.message || "An unexpected error occurred",
      apiError.status,
      apiError.details,
    );
  }

  return new AppError("An unknown error occurred");
};

export const isNetworkError = (error: unknown): boolean => {
  if (error instanceof AppError) {
    return !error.status || error.status >= 500;
  }
  return false;
};

export const isAuthError = (error: unknown): boolean => {
  if (error instanceof AppError) {
    return error.status === 401 || error.status === 403;
  }
  return false;
};
